var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.delayedActive && _vm.overlay)?_c('div',{class:[
        _vm.positionType,
        'z-60 left-0 top-0 h-full w-full bg-white/60 dark:bg-black/60',
      ]}):_vm._e()]),_c('LoadingLogo',{attrs:{"active":_vm.delayedActive,"size":_vm.size,"position":_vm.position,"position-type":_vm.positionType}}),(!_vm.delayedActive)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }